import { useTranslation } from '@aimsos/i18n';

/** Prototype badge tones — Source A = blue, Source B = purple. */
const BADGE_TONE = {
  a: 'bg-sky-600 text-white',
  b: 'bg-violet-600 text-white',
};

/**
 * Source A vs Source B comparison for a conflicted claim.
 * Matches the HTL prototype: one filled well, stacked inline rows
 * (badge + "label — value"), not side-by-side cards.
 */
function ConflictCompareBlock({ sourceA, sourceB }) {
  const { t } = useTranslation('work-queues-app');
  if (!sourceA && !sourceB) return null;

  const sides = [
    sourceA ? { key: 'a', tag: t('claims.sourceA'), src: sourceA } : null,
    sourceB ? { key: 'b', tag: t('claims.sourceB'), src: sourceB } : null,
  ].filter(Boolean);

  return (
    <div className="mt-3 rounded-md bg-surface-muted px-3 py-2.5">
      <div className="flex flex-col gap-2">
        {sides.map(({ key, tag, src }) => (
          <div key={key} className="flex min-w-0 items-center gap-2.5">
            <span
              className={[
                'inline-flex shrink-0 items-center rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide',
                BADGE_TONE[key],
              ].join(' ')}
            >
              {tag}
            </span>
            <p className="min-w-0 truncate text-sm leading-snug text-content-secondary">
              <span className="font-medium text-content">{src.label}</span>
              {' — '}
              {src.value}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ConflictCompareBlock;
